import React from 'react';
import './Header.css';
import './About.css';
import SEO from './SEO.js';

const seoData = {
  title: 'About CineRecs',
  description: 'CineRecs is a curated Movie & Series platform dedicated to bringing you the highest quality films complete with trailers and direct links to streaming services. Learn about our mission to help you discover great content.',
  keywords: 'about cinerecs, our mission, curated content, cinema platform mission, discover movies',
  canonical: 'https://cinerecs.com/about',
  ogImage: 'https://cinerecs.com/landing_logo.webp'
};

const About = () => (
  <div className="about-container">
    <SEO {...seoData}/>
    <h1>About Our Movie Platform</h1>
    <p>
      Welcome to our curated Movie & Series platform where we bring you the highest quality films 
      complete with trailers and direct links to streaming services. Our mission is to 
      help you discover great Movies & Series without the hassle of searching through endless options.
    </p>
    
    <h2>What We Offer</h2>
    <ul>
      <li>Handpicked selection of top-rated Movies & Series.</li>
      <li>Instant access to trailers.</li>
      <li>Direct links to streaming platforms where you can watch.</li>
      <li>Fresh recommendations updated every month.</li>
    </ul>
    
    <h2>Our Selection Process</h2>
    <p>
    We handpick our Movies & Series by combining ratings from trusted review platforms, overall popularity, and curated selections from our in-house team of film enthusiasts.
    This thoughtful approach ensures every recommendation is both critically acclaimed and genuinely loved by audiences.
    </p>
    <h2>Monthly Updates</h2>
    <p>
      Our collection is refreshed monthly to include new releases that meet our 
      quality standards and to remove titles that may no longer be available on 
      major streaming platforms. We strive to keep our recommendations current 
      and accessible.
    </p>
    
    <p className="closing">
      Happy watching! We hope you discover your next favorite Movie or Series through our page.
    </p>
  </div>
);

export default About;
